import React, { useState } from 'react';
import { connect } from 'react-redux';
import { setCurrentStep } from '../OwnershipTransferCustomerSlice';
import { OwnershipTransferCustomerStep } from '../Constant/Constant';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import ObligationData from '../../OwnershipTransferBlock/Shared/ObligationData';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { dwhGeneralReport, DWHStatus, DwhActionType, DWHMessageText } from '../Reports/dwhReports'

const Obligations = (props) => {
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      dwhGeneralReport({
        data: { ...props.data, userDetails: props.userDetails },
        actionType: DwhActionType.EquipmentChargesPage,
        messageText: DWHMessageText.EquipmentChargesPageDisplayed,
        status: DWHStatus.Ongoing
      });
    }
  }, []);
  const [error, setError] = useState(false);
  const [checkbox, setCheckbox] = useState([
    {
      id: 0,
      title: (
        <div className='checkboxes-title'>
          הרוכש והמוכר מבקשים כי הבעלות בציוד שפרטיו רשומים להלן תועבר לרוכש וכל סכום אשר חב המוכר ל {window.Config.brand_Name_HE} בגין רכישתו, אשר לא יסולק על ידי
          המוכר עד למועד העברת הבעלות, <span className='semi'>יחול מעתה על הרוכש</span> .אי סימון תיבה זו תותיר את החיובים המפורטים לעיל ואת
          הבעלות בציוד בידי המוכר.
        </div>
      ),
      checked: false,
    },
    {
      id: 0,
      title: (
        <div className='checkboxes-title'>
          אני הרוכש, מעוניין לשלם את יתרת התשלומים בגין מכשיר זה בתשלומים חודשיים ולא בתשלום חד פעמי (כל זאת אם היתרה לא תסולק ע״י המוכר).
        </div>
      ),
      checked: false,
    },
  ]);

  function onCheck(index) {
    let temp = [...checkbox];
    temp[index].checked = !temp[index].checked;
    setCheckbox(temp);
    setError(false);
  }

  function nextStep() {
    const checkedCount = checkbox.filter((ch) => ch.checked).length;
    if (checkedCount == checkbox.length) {
      dwhGeneralReport({
        data: { ...props.data, userDetails: props.userDetails },
        actionType: DwhActionType.EquipmentChargesPage,
        messageText: DWHMessageText.EquipmentChargesPageButtonClicked,
        status: DWHStatus.Ongoing
      });
      if (props.data.cellcomDu) {
        props.setCurrentStep(OwnershipTransferCustomerStep.CellcomDu);
      } else {
        props.setCurrentStep(OwnershipTransferCustomerStep.SubscriberPersonalData);
      }
    } else {
      setError(true);
    }
  }

  return (
    <div className='ownership-transfer-obligations'>
      <div className='stepContainer'>
        <div className='l-title center'>למנוי שלך קיים חיוב על מכשיר</div>
        <div className='m-title center'>
          המכשיר שברשותך עובר לבעלותך יחד עם החיוב. במידה ואינך רוצה להעביר את החיובים, יש לפנות לאיש הקשר
        </div>
        {props.data.currentEquipmentObligations.map((item, index) => {
          return <ObligationData item={item.currentPayment} key={index} />;
        })}

        <div className='checkboxes'>
          <div className='m-title semi'>
            בכדי להתקדם בתהליך יש
            <br /> לאשר את התנאים מטה
          </div>
          <div>
            {checkbox.map((item, index) => {
              return (
                <div className='transfer-checkbox' key={index}>
                  <CheckBox
                    id={index}
                    onCheck={() => onCheck(index)}
                    onUncheck={() => onCheck(index)}
                    checked={item.checked}
                    label={item.title}
                  />
                </div>
              );
            })}
          </div>
        </div>

        <div className='continue-button'>
          {error && <div className='error center'>כדי להמשיך יש לאשר את העברת החיובים</div>}
          <BtnSubmit onclick={nextStep} text={'אישור והמשך'} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransferCustomer,
  userDetails: state.authentication?.loginData?.userDetails,
});

const mapDispatchToProps = {
  setCurrentStep,
};

export default connect(mapStateToProps, mapDispatchToProps)(Obligations);
